@if (endorsementLocation?.endorsementImage && !displayEndorsementType) {
  <img
    class="endorsement-image"
    [src]="'data:image/png;base64,' + endorsementLocation?.endorsementImage"
    alt="unsupported endorsement"
    />
}

@if (displayEndorsementType) {
  <div>
    {{ endorsementLocation?.endorsementTypeCode }} ID:
    {{ endorsementLocation?.documentEndorsementLocationId }}
  </div>
}
